import {
  Box,
  Flex,
  Grid,
  Group,
  Image,
  Paper,
  Text,
  Title,
} from "@mantine/core";
import React from "react";
import style from "./AuthenticationTitle.module.css";
import { IconHttpPost } from "@tabler/icons-react";
import imageLogin from "../../../../assets/images/login.png";
import imageLogo from "../../../../assets/images/logoE-sign.png";

import { AuthenticationTitle } from "./_login";
const Forgetlogin = () => {
  return (
    <Box className={style.container_box} p={20}>
      <Grid m={0} className={style.form_login}>
        <Grid.Col
          className={style.content_form}
          span={{ base: 12, md: 6, lg: 5 }}
        >
          <Box className={style.logo}>
            <Image w={120} h={120} src={imageLogo} />
          </Box>
          <Box className={style.content_login}>
            <Title ta="center" order={1} mt={20} mb={40} c="#342e79" fw={700}>
              Phần mềm chữ ký điện tử
            </Title>
            <Box className={style.content}>
              <AuthenticationTitle />
            </Box>
          </Box>
        </Grid.Col>
        <Grid.Col
          className={style.content_images}
          span={{ base: 12, md: 6, lg: 7 }}
        >
          <Box className={style.imageUser}>
            {/* <Box className={style.images}></Box> */}
            <Image src={imageLogin} />
          </Box>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default Forgetlogin;
